<template>
  <v-container>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
          <patient-identity :patient="patient"></patient-identity>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs4>
          <v-card>
            <v-card-title>Previous Encounters</v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs4>
          <v-card>
            <v-card-title>Recent Observations</v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-card height="200px" text>
        <v-bottom-nav absolute color="transparent">
          <v-btn color="teal" text @click="newEncounter">Add Encounter<v-icon>description</v-icon></v-btn>
          <v-btn color="cyan" text @click="editPatient">Edit Patient Record<v-icon>description</v-icon></v-btn>
        </v-bottom-nav>
      </v-card>
    </v-container>
    <div v-if="encounters.length > 0" class="flex flex-col gap-4 lg:p-4 p-2 rounde-lg m-2">
      <h2 class="text-lg text-gray-700">Encounters</h2>
      <div v-for="(encounter, index) in encounters" :key="index" class="flex items-center justify-between w-full p-2 lg:rounded-full md:rounded-full hover:bg-gray-100 cursor-pointer border-2 rounded-lg">
        <!-- <div class="text-sm leading-3 text-gray-700 font-bold">{{encounter.period.start}}</div> -->
        <router-link :to="{ name: 'encounter-edit', params: { encounterId: encounter.systemId, orgName: $route.params.orgName, patientId: $route.params.patientId }}" class="text-sm leading-3 text-gray-700 font-bold">
          {{localeDate(encounter.period.start)}}
        </router-link>
      </div>
    </div>
  </v-container>
</template>

<script>
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'
import PatientIdentity from '@/components/PatientIdentity.vue'

dayjs.extend(customParseFormat)

export default {
  components: {
    PatientIdentity
  },
  data: () => ({
    encounters: [],
    identified: false,
    patient: {}
  }),
  methods: {
    editPatient () {
      this.$router.push({ name: 'patient-edit', params: { patientId: this.$route.params.patientId } })
    },
    localeDate: function (val) {
      if (val && dayjs(val).isValid()) return dayjs(val).format('DD/MM/YYYY')
      else return val
    },
    newEncounter () {
      if (this.$store.state.auth.user.managingOrganization === '902') {
        this.$router.push({ name: 'eye-encounter-edit', params: { encounterId: 'new', patientId: this.$route.params.patientId } })
      } else this.$router.push({ name: 'encounter-edit', params: { encounterId: 'new', patientId: this.$route.params.patientId } })
    }
  },
  async created () {
    const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patient/${this.$route.params.patientId}`)
    this.patient = results.data
    const encounterResults = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patient/${this.$route.params.patientId}/encounters`)
    this.encounters = encounterResults.data
  }
}
</script>
